import React from 'react';
import ContactGroupHead from './components/contact-group-head';
import ContactGroupBody from './components/contact-group-body';

function ContactGroup () {
	return (
		<div className="contact-group">
			<ContactGroupHead/>
			<ContactGroupBody/>
		</div>
	)
}

export default ContactGroup;
